import React from 'react';
import { Box } from '@mui/material';

const Badge = ({
  badgeText = '',
  badgeType = 'default', // 'default' | 'highlight' | 'expiry' etc.
  badgePosition = { top: 0, right: 0 },
  badgeSize = 'small',
  badgeSx = {},
}) => {
  const getBadgeStyles = () => {
    switch (badgeType) {
      case 'card':
        return {
          backgroundColor: '#CC00001F',
          border: '1px solid #c62828',
          color: '#333',
          borderRadius: '8px',
          padding: '4px 8px',
        };
      case 'list':
        return {
          backgroundColor: '#CC00001F',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
          border: '1px solid #CC0000',
          color: '#333',
          padding: '4px 8px',
        };
      default:
        return {
          backgroundColor: '#e0e0e0',
          borderRadius: '8px',
          padding: '2px 8px',
        };
    }
  };
  return (
    badgeText && (
      <Box
        component="span"
          sx={{
              position: 'absolute',
              top: badgePosition.top,
              right: badgePosition.right,
              fontWeight: 500,
              fontSize: badgeSize === 'small' ? '0.8rem' : '1rem',
              zIndex: 1,
              ...getBadgeStyles(),
              ...badgeSx,
          }}
      >
        {badgeText}
      </Box>
    )
  );
};

export default Badge;
